import { render, staticRenderFns } from "./ABAddOrEditText.vue?vue&type=template&id=62baa3dc&scoped=true"
import script from "./ABAddOrEditText.vue?vue&type=script&lang=js"
export * from "./ABAddOrEditText.vue?vue&type=script&lang=js"
import style0 from "./ABAddOrEditText.vue?vue&type=style&index=0&id=62baa3dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62baa3dc",
  null
  
)

export default component.exports